var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center justify-center",class:{
        'full-page': _vm.fullPage,
    }},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }